import styles from './styles.scss';

export const Backdrop = () => <div className={styles.backdrop} />;
